import { render, staticRenderFns } from "./page-detail-orders.vue?vue&type=template&id=ae54fa78&scoped=true&"
import script from "./page-detail-orders.vue?vue&type=script&lang=js&"
export * from "./page-detail-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae54fa78",
  null
  
)

export default component.exports